import apiClient from '../api.js';
import { conToken } from '../autorizacion.js';

// Capa de servicios del costo del crédito por sede, carrera, plan de estudios
// y GESTIÓN (HU-02): un costo vigente por gestión; una gestión sin costo propio
// hereda el de la anterior más cercana por `ord`. Backend: `UNICEN/modules/economico`.
// Contrato completo: UNICEN/modules/economico/docs/costos-credito.openapi.yaml
//
// Mismas convenciones que useFactoresCreditoApi: token obligatorio, `{ data }`,
// errores `{ mensaje, campo?, rechazadas? }` (leer con `errorDeApi`).
//
//   GET  /economico/costos-credito?id_gestion&id_sede&incluir_inactivos&solo_sin_vigente
//        -> [{ combinacion, vigente: Costo|null, programados: [Costo] }]
//        `combinacion` trae carrera y `tipo_plan`: es la lista para elegir.
//        `vigente.heredado` = true: rige por herencia; su `id_gestion` / `gestion`
//        son los de la gestión de origen.
//
//   GET  /economico/costos-credito/:id_sede/:id_carrera/:id_plan_estudio
//        -> { combinacion, hoy, fecha_minima_inicio, cargas: [Costo] }  (todas las gestiones)
//
//   POST /economico/costos-credito/cargas
//        body { combinaciones: [{ id_sede, id_carrera, id_plan_estudio }],
//               id_gestion, monto, id_tipo_moneda, fecha_inicio, simular }
//        200 simulación (o nada que guardar) | 201 guardado
//        -> { simulacion, lote, resumen: { total, registradas, sin_cambios,
//             rechazadas }, resultados: [{ combinacion, resultado, registrada,
//             cerrada, reemplazadas, error }] }
//        400 con `campo`, 404 si un plan no existe (`rechazadas`), 409 si algún
//        plan fue rechazado (`rechazadas`). En 404/409 no se guardó nada.
//
//   Costo: { id_costo_credito, id_lote, id_gestion, gestion, heredado, monto, id_tipo_moneda, moneda: 'Bs'|'$us',
//            fecha_inicio, fecha_fin, estado: 'VIGENTE'|'PROGRAMADO'|
//            'FINALIZADO'|'REEMPLAZADO', id_reemplazado_por, id_usuario,
//            usuario, registrado_en }

const resource = '/economico/costos-credito';

const useCostosCreditoApi = {
  listar({
    id_gestion, id_sede, incluir_inactivos = false, solo_sin_vigente = false,
  } = {}) {
    return apiClient.get(resource, conToken({
      params: {
        id_gestion, id_sede, incluir_inactivos, solo_sin_vigente,
      },
    }));
  },

  historial({ id_sede, id_carrera, id_plan_estudio }) {
    return apiClient.get(`${resource}/${id_sede}/${id_carrera}/${id_plan_estudio}`, conToken());
  },

  cargar({
    combinaciones, id_gestion, monto, id_tipo_moneda, fecha_inicio, simular,
  }) {
    return apiClient.post(
      `${resource}/cargas`,
      {
        combinaciones, id_gestion, monto, id_tipo_moneda, fecha_inicio, simular,
      },
      conToken()
    );
  },
};

export default useCostosCreditoApi;
